import { configureStore } from '@reduxjs/toolkit';
import localforage from 'localforage';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import thunk from 'redux-thunk';
import { MW_5_11_0 } from '@rsos/reduxDataStore/src/constants/migrationVersions';
import { rsosApi } from '@rsos/reduxDataStore/src/features/rsosApi';
import rootReducer from './app/rootReducer';

// redux-persist setup
const persistConfig = {
  key: 'root',
  version: MW_5_11_0,
  storage: localforage,
  stateReconciler: autoMergeLevel2,
  blacklist: [
    rsosApi.reducerPath,
    'incidents',
    'rad',
    'medicalert',
    'spatialLayers',
    'emergencyCalls',
    'search',
    'gisServices',
    'axon',
    'eagleEye',
    'mapCard', // do not persist. not allowed to store axon data
    'schemas',
    'gisSearch',
    'mapPopover',
    'what3words',
  ],
};
const pReducer = persistReducer(persistConfig, rootReducer);
export const store = configureStore({
  // TODO: no need to use pReducer here. this causes the emergency_data store to leak into every app with the persisted root reducer
  reducer: pReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(thunk, rsosApi.middleware),
});

export const persistor = persistStore(store);
